import { Coins } from 'lucide-react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { User } from '../../service/api';

interface ManagerUserCardProps {
  user: User;
  balance: number;
  onManageStickers: () => void;
  onViewTransactions: () => void;
  onManageInventory: () => void;
  onManageEffects: () => void;
}

export default function ManagerUserCard({
  user,
  balance,
  onManageStickers,
  onViewTransactions,
  onManageInventory,
  onManageEffects,
}: ManagerUserCardProps) {
  const { t } = useTranslation();

  return (
    <Card className="mb-3 shadow-sm border">
      <Card.Body>
        <Row className="align-items-center">
          <Col xs="auto">
            {user.picture ? (
              <img
                src={user.picture}
                alt={user.given_name}
                className="rounded-circle"
                style={{ width: '48px', height: '48px', objectFit: 'cover' }}
              />
            ) : (
              <div
                className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white fw-bold"
                style={{ width: '48px', height: '48px' }}
              >
                {user.given_name[0]}
                {user.family_name[0]}
              </div>
            )}
          </Col>
          <Col>
            <h6 className="mb-1">
              {user.given_name} {user.family_name}
            </h6>
            <p className="text-muted small mb-0">{user.email}</p>
          </Col>
          <Col xs="auto" className="text-end">
            <div className="d-flex align-items-center gap-2 mb-2">
              <span className="fw-bold">{balance}</span>
              <Coins size={20} className="text-warning" />
            </div>
            <div className="d-flex gap-2 justify-content-end flex-wrap flex-md-nowrap">
              <Button
                variant="outline-primary"
                size="sm"
                onClick={onManageStickers}
              >
                {t('manager.users.labels.stickers')}
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={onViewTransactions}
              >
                {t('manager.users.labels.transactions')}
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={onManageInventory}
              >
                {t('manager.users.labels.inventory')}
              </Button>
              <Button
                variant="outline-info"
                size="sm"
                onClick={onManageEffects}
              >
                ⚡ {t('manager.users.labels.effects')}
              </Button>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
